/**
 * Get the stop time based on the isCallingSoon property
 * @param value - The estimated call object
 * @returns The stop time
 */
export function getStopTime(value: { isCallingSoon?: boolean; aimedStopTime: Date; expectedStopTime?: Date }) {
    return value.isCallingSoon && value.expectedStopTime ? value.expectedStopTime : value.aimedStopTime;
}
